module.exports = __webpack_public_path__ + "static/neemia-f3e9e18427ad0872dd48d6ccb24f90b7.svg";